import { render } from "./PVDisclaimer.vue?vue&type=template&id=bb280594"
import script from "./PVDisclaimer.vue?vue&type=script&lang=js"
export * from "./PVDisclaimer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__